import { ChecklistResult } from '@/utils/config';
import axios from 'axios';
import authHeader from './auth-header';

class ChecklistService {

    
    postData(data){
        console.log(data);
        return axios
            .post(ChecklistResult, data, { headers: authHeader() })
            .then(response => {
               return response.data.data;
            });
    }
}

export default new ChecklistService();